export const API_V1_PATH = "/api/v1";
